import { computed, Ref, unref } from 'vue';
import { UseQueryConfigV2, useQueryV2 } from '@libs/use';

import * as API from '../../requests';
import { PORTFOLIO_QUERY_KEYS } from '../../constants';

type UseGetEmbeddedPutOptionSymbolInfoOptions = {
  isin: Ref<string>;
  immediate: boolean;
  onReject?: UseQueryConfigV2<object>['onReject'];
  onSuccess?: UseQueryConfigV2<object>['onSuccess'];
};

export default function useGetEmbeddedPutOptionSymbolInfoQuery({
  isin,
  immediate,
  onReject,
  onSuccess,
}: UseGetEmbeddedPutOptionSymbolInfoOptions) {
  const {
    result,
    execute: getEmbeddedPutOptionSymbolInfo,
    isPending: isLoadingEmbeddedPutOptionSymbolInfo,
    isSuccess: isSuccessLoadingEmbeddedPutOptionSymbolInfo,
    isError: isErrorLoadingEmbeddedPutOptionSymbolInfo,
    isRevalidating: isRevalidatingEmbeddedPutOptionSymbolInfo,
  } = useQueryV2(() => API.getEmbeddedPutOptionSymbolInfo(unref(isin)), {
    key: PORTFOLIO_QUERY_KEYS.embeddedPutOptionSymbolInfo(isin),
    immediate,
    onSuccess,
    onReject,
  });

  const embeddedPutOptionSymbolInfo = computed(() => result.value?.data);

  return {
    embeddedPutOptionSymbolInfo,
    getEmbeddedPutOptionSymbolInfo,
    isLoadingEmbeddedPutOptionSymbolInfo,
    isSuccessLoadingEmbeddedPutOptionSymbolInfo,
    isErrorLoadingEmbeddedPutOptionSymbolInfo,
    isRevalidatingEmbeddedPutOptionSymbolInfo,
  };
}
